// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__bzePq","label":"Labeled_label__2SHr3","divider":"Labeled_divider__32Uj0"};